module.exports = __webpack_public_path__ + "static/media/TruckBulkUpload.590edbcf.xlsx";